(function($) {
    "use strict";

    // Preloader start
    $(window).on('load', function() {
        $(".preloder_part").fadeOut();
        $(".spinner").delay(1000).fadeOut("slow");
    });
    // preloader end

    // back to top start
    $(window).scroll(function() {
        if ($(this).scrollTop() > 200) {
            $('.backtotop:hidden').stop(true, true).fadeIn();
        } else {
            $('.backtotop').stop(true, true).fadeOut();
        }
    });
    $(function() {
        $(".scroll").on('click', function() {
            $("html,body").animate({ scrollTop: 0 }, "slow");
            return false
        });
    });

    // mobile menu start
    $('#mobile-menu-active').metisMenu();

    $('#mobile-menu-active .dropdown > a').on('click', function(e) {
        e.preventDefault();
    });

    $(".hamburger_menu > a").on("click", function(e) {
        e.preventDefault();
        $(".slide-bar").toggleClass("show");
        $("body").addClass("on-side");
        $('.body-overlay').addClass('active');
        $(this).addClass('active');
    });

    $(".close-mobile-menu > a").on("click", function(e) {
        e.preventDefault();
        $(".slide-bar").removeClass("show");
        $("body").removeClass("on-side");
        $('.body-overlay').removeClass('active');
        $('.hamburger_menu > a').removeClass('active');
    });

    $('.body-overlay').on('click', function() {
        $(this).removeClass('active');
        $(".slide-bar").removeClass("show");
        $("body").removeClass("on-side");
        $('.hamburger-menu > a').removeClass('active');
    });
    // mobile menu end

    // Off Canvas - Start
    // --------------------------------------------------
    $(document).ready(function() {
        $('.cart_close_btn, .body-overlay').on('click', function() {
            $('.cart_sidebar').removeClass('active');
            $('.body-overlay').removeClass('active');
        });

        $('.cart_btn').on('click', function() {
            $('.cart_sidebar').addClass('active');
            $('.body-overlay').addClass('active');
        });
    });

    // testimonial start
    $('.hero__product-carousel').slick({
        dots: false,
        arrows: false,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        asNavFor: '.hero__product-carousel-nav'
    });

    $('.hero__product-carousel').on('mousedown', 'a', function(e) {
        e.stopPropagation(); // Allow link clicks inside slick slides
    });

    $('.hero__product-carousel-nav').slick({
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        focusOnSelect: true,
        verticalSwiping: true,
        centerPadding: 0,
        asNavFor: '.hero__product-carousel',
        prevArrow: '<button type="button" class="slick-prev"><i class="fal fa-long-arrow-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fal fa-long-arrow-right"></i></button>',
    });

    // widget post 
    $('.hot-deal__slide').slick({
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: '<i class="slick-arrow slick-prev far fa-angle-left"></i>',
        nextArrow: '<i class="slick-arrow slick-next far far fa-angle-right"></i>',
    });

    // tab product 
    $('.tab-product__slide').slick({
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: '<i class="slick-arrow slick-prev far fa-angle-left"></i>',
        nextArrow: '<i class="slick-arrow slick-next far far fa-angle-right"></i>',
        responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    // category product 
    $('.rd-product__slide').slick({
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: '<i class="slick-arrow slick-prev far fa-angle-left"></i>',
        nextArrow: '<i class="slick-arrow slick-next far far fa-angle-right"></i>',
        responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    $('.brand__active').slick({
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 6,
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    });

    // Accordion Box start
    if ($(".accordion_box").length) {
        $(".accordion_box").on("click", ".acc-btn", function() {
            var outerBox = $(this).parents(".accordion_box");
            var target = $(this).parents(".accordion");

            if ($(this).next(".acc_body").is(":visible")) {
                $(this).removeClass("active");
                $(this).next(".acc_body").slideUp(300);
                $(outerBox).children(".accordion").removeClass("active-block");
            } else {
                $(outerBox).find(".accordion .acc-btn").removeClass("active");
                $(this).addClass("active");
                $(outerBox).children(".accordion").removeClass("active-block");
                $(outerBox).find(".accordion").children(".acc_body").slideUp(300);
                target.addClass("active-block");
                $(this).next(".acc_body").slideDown(300);
            }
        });
    }
    // Accordion Box end


    if ($("input.product-count").length) {
        $("input.product-count").TouchSpin({
            min: 1,
            max: 1000,
            step: 1,
            buttondown_class: "btn btn-link",
            buttonup_class: "btn btn-link",
        });

        $("input.product-count").on('change input', function() {
            $('[name="update_cart"]').prop('disabled', false).removeClass('disabled');
        });
    }

    // Single product quantity +/- buttons
    $(document).on('click', '.bootstrap-touchspin-up', function() {
        var $input = $(this).closest('.bootstrap-touchspin').find('input[name="quantity"]');
        var val = parseInt($input.val(), 10);
        var max = parseInt($input.attr('max'), 10);
        var step = parseInt($input.attr('step'), 10) || 1;
        if (isNaN(val)) val = 1;
        if (!isNaN(max) && val >= max) return;
        $input.val(val + step).trigger('change');
    });

    $(document).on('click', '.bootstrap-touchspin-down', function() {
        var $input = $(this).closest('.bootstrap-touchspin').find('input[name="quantity"]');
        var val = parseInt($input.val(), 10);
        var min = parseInt($input.attr('min'), 10) || 1;
        var step = parseInt($input.attr('step'), 10) || 1;
        if (isNaN(val)) val = min;
        if (val <= min) return;
        $input.val(val - step).trigger('change');
    });

    if ($(".checkout-section").length) {
        var showLogInBtn = $(".woocommerce-info > a");
        var showCouponBtn = $(".showcoupon");
        var shipDifferentAddressBtn = $("#ship-to-different-address");
        var loginForm = $("form.login");
        var couponForm = $(".checkout_coupon");
        var shippingAddress = $(".shipping_address");

        loginForm.hide();
        couponForm.hide();
        shippingAddress.hide();

        showLogInBtn.on("click", function(event) {
            event.preventDefault();
            loginForm.slideToggle();
            event.stopPropagation();
        });

        showCouponBtn.on("click", function(event2) {
            event2.preventDefault();
            couponForm.slideToggle();
            event2.stopPropagation();
        })

        shipDifferentAddressBtn.on("click", function(event3) {
            shippingAddress.slideToggle();
            event3.stopPropagation();
        })
    }

    if ($("#slider-range").length) {
        $("#slider-range").slider({
            range: true,
            min: 12,
            max: 200,
            values: [0, 100],
            slide: function(event, ui) {
                $("#amount").val("$" + ui.values[0] + " - $" + ui.values[1]);
            }
        });

        $("#amount").val("$" + $("#slider-range").slider("values", 0) + " - $" + $("#slider-range").slider("values", 1));
    }

    $(document).on('click', '.variation-option', function() {
        var $pill = $(this);
        var $wrap = $pill.closest('.model-option-wrap');
        var $select = $wrap.find('select.variation-select');

        $wrap.find('.variation-option').removeClass('active');
        $pill.addClass('active');

        $select.val($pill.data('value')).trigger('change');
    });

    // When WooCommerce resolves a valid variation, sync its price into the main price display.
    $(document).on('found_variation', '.variations_form', function(e, variation) {
        if (!variation.price_html) return;
        var $amount = $('<div>').html(variation.price_html).find('.woocommerce-Price-amount');
        if ($amount.length) {
            $('.price .woocommerce-Price-amount').html($amount.first().html());
        }
    });

    // Store original price HTML on page load so we can restore it when variation is reset.
    $(document).ready(function() {
        var $priceEl = $('.price .woocommerce-Price-amount');
        if ($priceEl.length) {
            $priceEl.data('original-html', $priceEl.html());
        }

        // Disable the add-to-cart button until a variation is selected.
        $('.variations_form .single_add_to_cart_button').prop('disabled', true);
    });

    $(document).on('found_variation', '.variations_form', function() {
        $(this).find('.single_add_to_cart_button').prop('disabled', false).removeClass('disabled wc-variation-selection-needed wc-variation-is-unavailable');
    });

    $(document).on('reset_data hide_variation', '.variations_form', function() {
        $(this).find('.single_add_to_cart_button').prop('disabled', true);
    });

    $(document).on('reset_data', '.variations_form', function() {
        var $priceEl = $('.price .woocommerce-Price-amount');
        var original = $priceEl.data('original-html');
        if (original) {
            $priceEl.html(original);
        }
    });

    // Cart page: remove item row from DOM immediately after WooCommerce's AJAX removal.
    //
    // WooCommerce cart.js intercepts .product-remove > a clicks, does a GET request,
    // and calls update_wc_div() which replaces .woocommerce-cart-form with fresh HTML
    // from the response when items remain.  When the last item is removed it swaps the
    // entire .woocommerce-cart-form__contents wrapper with the empty-cart block.
    // In both cases the event fired AFTER the DOM update is "item_removed_from_classic_cart".
    //
    // However the DOM replacement only works when the response HTML is parsed correctly.
    // As a safety net we also manually fade-out the row, which is a no-op if WooCommerce
    // already removed it via replaceWith().
    $(document).on('click', '.woocommerce-cart-form .product-remove > a', function() {
        var $row = $(this).closest('tr');
        $(document.body).one('item_removed_from_classic_cart', function() {
            // If WooCommerce already removed the row via replaceWith, $row is detached
            // and fadeOut is harmless. If it's still attached, remove it now.
            if ($.contains(document, $row[0])) {
                $row.fadeOut(300, function() { $row.remove(); });
            }
        });
    });

    // Shop filters off-canvas (mobile < 992px)
    $('#btn-shop-filters').on('click', function() {
        $('#shop-sidebar-offcanvas').addClass('is-open');
        $('#shop-sidebar-backdrop').addClass('is-active');
        $('body').addClass('offcanvas-filters-open');
    });

    function closeShopFilters() {
        $('#shop-sidebar-offcanvas').removeClass('is-open');
        $('#shop-sidebar-backdrop').removeClass('is-active');
        $('body').removeClass('offcanvas-filters-open');
    }

    $('#shop-sidebar-close, #shop-sidebar-backdrop').on('click', closeShopFilters);

})(jQuery);